export const options = {
    YESORNO: ['Sí', 'No'],
    COMBUSTIBLE: [{
        10: 'MÍNIMO',
        25: '1/4 TANQUE',
        50: '1/3 TANQUE',
        75: '3/4 TANQUE',
        100: 'MÁXIMO'
    }]
}